import { render, staticRenderFns } from "./BannerCarousel.vue?vue&type=template&id=08c02b60&scoped=true"
import script from "./BannerCarousel.vue?vue&type=script&lang=js"
export * from "./BannerCarousel.vue?vue&type=script&lang=js"
import style0 from "./BannerCarousel.vue?vue&type=style&index=0&id=08c02b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c02b60",
  null
  
)

export default component.exports